import React, { SVGProps } from "react";

export function TextIconComponent({
    color = "currentColor",
    size = "20",
    className = null,
}) {
    const props: SVGProps<SVGSVGElement> = {
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 20 20",
        fill: "none",
    };
    if (className) props.className = className;

    return (
        <svg {...props}>
            <path
                d="M14 0H6C2.691 0 0 2.691 0 6V19C0 19.2652 0.105357 19.5196 0.292893 19.7071C0.48043 19.8946 0.734784 20 1 20H14C17.309 20 20 17.309 20 14V6C20 2.691 17.309 0 14 0ZM12 13H5V11H12V13ZM15 9H5V7H15V9Z"
                fill={color}
            />
        </svg>
    );
}
